export const ALLIED = 'ALLIED'
export const AUSPOST = 'AUSPOST'
export const AUSPOSTINTERNATIONAL = 'AUSPOST_INTERNATIONAL'
export const DIRECT = 'DIRECT'
export const DSE = 'DSE'
export const ICSWMS = 'IcsWMS'
export const MACHSHIP = 'MACHSHIP'
export const SMARTSEND = 'SMART/SEND'
export const STARSHIPIT = 'STARSHIPIT'
